import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  setKidsSafetyInReservationEdit,
  setChildrenNumber,
  setAdultsNumber
} from 'components/actions/serviceActions';
import Counter from 'components/components/booking/components/Counter';
import withRouter from 'components/components/common/withRouter';
import SafetyList from 'components/components/booking/KidsSafety/components/SafetyList';
import { scrollTo } from 'components/helpers/scrollToElement';
import T from 'components/common/translations/Translate';

class ReservationEditPassengers extends Component {

  onChangeCounter = (value) => {
    this.props.setChildrenNumber(value);
    // if (value > 0) {
    //   scrollTo({
    //     elementId: 'sectionKids',
    //     secondContainerSelector: '#editHolder',
    //     width: this.props.windowWidth,
    //     manuallOffset: -70
    //   });
    // }
  }

  render() {
    return (
      <div className="grid-layout__content-wrap">
        <div className="content__desc">
          <div className="passenger-edit">
            <div className="content__desc-head">
              <h4><T>content.reservationEdit.reservationEditPassengers.title</T></h4>
              <div id={'sectionPassengers'}>
                <p><T>content.reservationEdit.reservationEditPassengers.desc</T></p>
              </div>
            </div>
            <ul className="amount-people">
              <li className="amount-people__item">
                <div className="amount-people__label"><T>content.reservationEdit.reservationEditPassengers.adults</T></div>
                <Counter
                  onChange={this.props.setAdultsNumber}
                  number={this.props.adultsNumber}
                />
              </li>

              <li className="amount-people__item">
                <div className="amount-people__label"><T>content.reservationEdit.reservationEditPassengers.kids</T> <span>(under 12 y)</span></div>
                <Counter
                  onChange={this.onChangeCounter}
                  number={this.props.childrenNumber}
                />
              </li>
            </ul>

            {this.props.childrenNumber > 0 &&
              <Fragment>
                <div id="sectionKids" className="content__desc-head">
                  <h4><T>content.reservationEdit.reservationEditPassengers.kidsSafetyTitle</T></h4>
                </div>

                <div className="text-center">
                  <p
                    className="no-marg"
                    style={{ marginBottom: '-2px!important' }}
                  >
                    <T>content.reservationEdit.reservationEditPassengers.tripMessage</T>
                  </p>
                  <p style={{ marginBottom: '7px' }}><T>content.reservationEdit.reservationEditPassengers.carSeatsMessage</T></p>
                </div>

                <SafetyList
                  childrenNumber={this.props.childrenNumber}
                  kidsSafety={this.props.kidsSafety}
                  setKidsSafetyNumber={this.props.setKidsSafetyInReservationEdit}
                  locale={this.props.locale}
                />
              </Fragment>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    childrenNumber: state.service.paramsForReservationUpdate.children,
    adultsNumber: state.service.paramsForReservationUpdate.adults,
    kidsSafety: state.service.paramsForReservationUpdate.kidsSafety,
    locale: state.app.locale
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setChildrenNumber, setAdultsNumber, setKidsSafetyInReservationEdit }
  )(ReservationEditPassengers)
);
